import { useBreadcrumbTitle } from "@msuite/ui/app-shell";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import { OrderStateTag } from "@msuite/ui/tag";
import { getOrderNumberString, getSuborderNumberString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import { useSuborder } from "@/hooks/use-suborder";
import type { SuborderPanelBaseProps } from "./shared";

export function SuborderHeader({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { suborder } = useSuborder(orderId, suborderId);

	/** Effects */
	// The card names the suborder's crumb; the order's sits one crumb above it, and the order's own
	// header is not on this page to name it.
	useBreadcrumbTitle(orderId, suborder ? getOrderNumberString(suborder.orderNumber) : null);

	/** Guard */
	if (!suborder) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon("Package")}
			title={getSuborderNumberString({
				orderNumber: suborder.orderNumber,
				suborderNumber: suborder.number,
			})}
			identifier={suborder.id}
		>
			<div className="justify-between items-center h-stack">
				<div className="h-stack">
					<OrderStateTag state={suborder.state} />
					<p>{guardString(suborder.warehouseZoneName)}</p>
				</div>
				<Link href={`/orders/${orderId}`}>
					{`${t("stock.order")} ${getOrderNumberString(suborder.orderNumber)}`}
				</Link>
			</div>
		</ContentCard>
	);
}
